module.exports = __webpack_public_path__ + "static/img/icon_.ebca3b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_.png
// module id = 5oy/
// module chunks = 1